export default __webpack_public_path__ + "static/media/zenodo-switch.577d235c.png";